module.exports = __webpack_public_path__ + "static/media/Association of TeleServices International Logo.64422f5a.png";